import React, { useEffect, useState, useRef } from 'react';
import HeroSection from '../components/HeroSection';
import { CURRENT_YEAR, YEARS_SINCE_OPENING } from '../utils/clinicInfo';
import { useLocation, useNavigate } from 'react-router-dom';
import useSwipe, { SWIPE_STYLE } from '../hooks/useSwipe';

const doctors = [
  {
    name: '한지은 원장',
    title: '대표원장',
    image: '/assets/한지은원장.webp',
    profile: [
      '치의학 석사',
      '이화여자대학교 졸업',
      '부산대 치의학전문대학원 졸업',
      '서울대 치의학교육연수원 수료',
      '대한치과보철학회 정회원',
      '대한치과보존학회 정회원',
      '오스템임플란트 연구자문위원',
      '포인트임플란트 연구자문위원',
      '메가젠임플란트 연구자문위원',
      '오스템 AIC course 수료',
      '메가젠 solution course 수료',
      '덴티움 practical hands-on 과정 이수',
      '턱관절/보톡스 교육과정 수료',
      '고수진 교정연수회 수료',
      '전) 하나인치과병원 소아치과 과장',
      '전) 일등플란트치과 원장'
    ]
  },
  {
    name: '손용준 원장',
    title: '대표원장',
    image: '/assets/손용준원장.webp',
    profile: [
      '치의학 석사',
      '공학 석사 (KAIST 전자전산학과)',
      '한국과학영재학교 졸업',
      'KAIST (한국과학기술원) 졸업',
      '부산대 치의전문대학원 졸업',
      '서울대 치의학교육연수원 수료',
      '부산시 치과의사회 표창장 수상',
      '대한구강악안면임플란트학회 정회원',
      '오스템임플란트 연구자문위원',
      '포인트임플란트 연구자문위원',
      '메가젠임플란트 연구자문위원',
      '오스템 AIC course 수료',
      '메가젠 solution course 수료',
      '턱관절/보톡스 교육과정 수료',
      '전) 하나인치과병원 보존보철과 과장',
      '전) 서울치과의원 원장'
    ]
  }
];

// 카카오 맵 컴포넌트
const KakaoMap = () => {
  const [, setMap] = useState(null);
  const [, setMarker] = useState(null);

  useEffect(() => {
    const initMap = () => {
      if (window.kakao && window.kakao.maps) {
        const container = document.getElementById('kakao-map');
        if (!container) return;

        // 초기 지도 설정 (대략적인 덕산읍 위치)
        const options = {
          center: new window.kakao.maps.LatLng(36.7061745, 127.4360238),
          level: 3
        };

        const mapInstance = new window.kakao.maps.Map(container, options);
        setMap(mapInstance);

        // 주소-좌표 변환 객체 생성
        const geocoder = new window.kakao.maps.services.Geocoder();

        // 정확한 주소로 좌표 검색
        const address = '충북 진천군 덕산읍 공원로 4';
        
        geocoder.addressSearch(address, function(result, status) {
          // 정상적으로 검색이 완료됐으면 
          if (status === window.kakao.maps.services.Status.OK) {
            const coords = new window.kakao.maps.LatLng(result[0].y, result[0].x);
            
            // 지도 중심을 검색된 좌표로 이동
            mapInstance.setCenter(coords);
            
            // 마커 생성
            const markerInstance = new window.kakao.maps.Marker({
              map: mapInstance,
              position: coords
            });
            
            setMarker(markerInstance);

            // 인포윈도우 생성
            const infowindow = new window.kakao.maps.InfoWindow({
              content: `
                <div style="padding:15px; width:250px; text-align:center;">
                  <strong style="color:#2563eb; font-size:16px;">한앤손부부치과</strong><br>
                  <span style="color:#666; font-size:14px;">충북 진천군 덕산읍 공원로 4</span><br>
                  <span style="color:#666; font-size:13px;">JH빌딩 3층</span><br>
                  <span style="color:#2563eb; font-weight:bold; font-size:14px;">043-534-3434</span>
                </div>
              `
            });

            // 마커에 클릭이벤트 등록
            window.kakao.maps.event.addListener(markerInstance, 'click', function() {
              infowindow.open(mapInstance, markerInstance);
            });

            // 처음에 인포윈도우 열어두기
            infowindow.open(mapInstance, markerInstance);
            
          } else {
            // 주소 검색이 실패한 경우 지번 주소로 재시도
            const jibunAddress = '충북 진천군 덕산읍 두촌리 2575';
            
            geocoder.addressSearch(jibunAddress, function(result, status) {
              if (status === window.kakao.maps.services.Status.OK) {
                const coords = new window.kakao.maps.LatLng(result[0].y, result[0].x);
                
                mapInstance.setCenter(coords);
                
                const markerInstance = new window.kakao.maps.Marker({
                  map: mapInstance,
                  position: coords
                });
                
                setMarker(markerInstance);

                const infowindow = new window.kakao.maps.InfoWindow({
                  content: `
                    <div style="padding:15px; width:250px; text-align:center;">
                      <strong style="color:#2563eb; font-size:16px;">한앤손부부치과</strong><br>
                      <span style="color:#666; font-size:14px;">충북 진천군 덕산읍 공원로 4</span><br>
                      <span style="color:#666; font-size:13px;">JH빌딩 3층</span><br>
                      <span style="color:#2563eb; font-weight:bold; font-size:14px;">043-534-3434</span>
                    </div>
                  `
                });

                window.kakao.maps.event.addListener(markerInstance, 'click', function() {
                  infowindow.open(mapInstance, markerInstance);
                });

                infowindow.open(mapInstance, markerInstance);
              } else {
                // 기본 좌표로 마커 생성
                const defaultCoords = new window.kakao.maps.LatLng(36.7061745, 127.4360238);
                const markerInstance = new window.kakao.maps.Marker({
                  map: mapInstance,
                  position: defaultCoords
                });
                setMarker(markerInstance);
              }
            });
          }
        });
      }
    };

    // 카카오 맵 SDK 로딩 확인
    if (window.kakao && window.kakao.maps) {
      initMap();
    } else {
      const checkKakaoMap = setInterval(() => {
        if (window.kakao && window.kakao.maps) {
          clearInterval(checkKakaoMap);
          initMap();
        }
      }, 100);
    }
  }, []);

  return <div id="kakao-map" className="w-full h-full"></div>;
};

// 병원 이야기 이미지 슬라이더
// (페이지 컴포넌트 밖에 두어야 사진을 넘길 때 슬라이더 3개가 매번 새로 그려지지 않음)
const ImageSlider = ({ images, currentSlide, setCurrentSlide, showDescription = false, title, isSquareRatio = false, showThumbnails = false }) => {
  const thumbnailContainerRef = useRef(null);
  const [imageLoaded, setImageLoaded] = useState(false);

  // 현재 사진이 다 뜨면 다음/이전 사진을 미리 받아둠 (넘길 때 바로 보이도록)
  const nextSrc = images[(currentSlide + 1) % images.length].src;
  const prevSrc = images[(currentSlide - 1 + images.length) % images.length].src;
  useEffect(() => {
    if (!imageLoaded) return;
    [nextSrc, prevSrc].forEach((src) => {
      const img = new Image();
      img.src = src;
    });
  }, [imageLoaded, nextSrc, prevSrc]);
  
  // 데스크톱에서 썸네일 자동 스크롤
  const scrollToThumbnail = (slideIndex) => {
    if (!showThumbnails || !thumbnailContainerRef.current || window.innerWidth < 768) return;
    
    const container = thumbnailContainerRef.current;
    // 현재 컨테이너 내에서만 썸네일 찾기
    const targetThumbnail = container.querySelector(`[data-thumbnail-index="${title}-${slideIndex}"]`);
    
    if (targetThumbnail) {
      const containerRect = container.getBoundingClientRect();
      const thumbnailRect = targetThumbnail.getBoundingClientRect();
      
      // 썸네일이 화면에 보이지 않을 때만 스크롤
      const isVisible = thumbnailRect.left >= containerRect.left && thumbnailRect.right <= containerRect.right;
      
      if (!isVisible) {
        const scrollLeft = targetThumbnail.offsetLeft - container.clientWidth / 2 + targetThumbnail.clientWidth / 2;
        container.scrollTo({
          left: Math.max(0, scrollLeft),
          behavior: 'smooth'
        });
      }
    }
  };

  // 슬라이드 변경 시 로딩 상태 관리
  const changeSlide = (newSlide) => {
    setImageLoaded(false);
    setCurrentSlide(newSlide);
    setTimeout(() => scrollToThumbnail(newSlide), 100);
  };

  // 슬라이드 네비게이션
  const nextSlide = () => {
    const newSlide = (currentSlide + 1) % images.length;
    changeSlide(newSlide);
  };

  const prevSlide = () => {
    const newSlide = (currentSlide - 1 + images.length) % images.length;
    changeSlide(newSlide);
  };

  // 옆으로 밀어서 다음/이전 사진으로 이동
  const swipeHandlers = useSwipe(nextSlide, prevSlide);

  const goToSlide = (index) => {
    if (index === currentSlide) return; // 같은 슬라이드면 아무것도 하지 않음
    setImageLoaded(false);
    setCurrentSlide(index);
  };

  return (
    <div className="bg-white rounded-2xl md:rounded-3xl p-6 md:p-10 shadow-lg border border-gray-100">
      <div className="text-center mb-6 md:mb-8">
        <h3 className="text-xl md:text-2xl font-bold text-primary mb-2">{title}</h3>
        <div className="w-16 h-1 bg-primary mx-auto rounded-full"></div>
      </div>
      
      <div className="relative max-w-5xl mx-auto">
        {/* 메인 이미지 */}
        <div className="relative overflow-hidden rounded-xl md:rounded-2xl shadow-lg bg-gray-100" {...swipeHandlers} style={SWIPE_STYLE}>
          <div 
            className="relative w-full" 
            style={{ paddingBottom: isSquareRatio ? '75%' : '56.25%' }}
          >
            {/* 로딩 스피너 */}
            {!imageLoaded && (
              <div className="absolute inset-0 flex items-center justify-center bg-gray-100">
                <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary"></div>
              </div>
            )}
            
            <img
              src={images[currentSlide].src}
              alt={images[currentSlide].title || `${title} 이미지`}
              className={`absolute inset-0 w-full h-full object-cover transition-opacity duration-300 ${
                imageLoaded ? 'opacity-100' : 'opacity-0'
              }`}
              loading="lazy"
              decoding="async"
              onLoad={() => setImageLoaded(true)}
              onError={() => setImageLoaded(true)}
            />
            
            {/* 데스크톱에서만 오버레이 텍스트 표시 */}
            {showDescription && images[currentSlide].title && (
              <div className="hidden md:block absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/70 to-transparent p-6">
                <div className="text-white">
                  <h4 className="text-2xl font-bold mb-2">{images[currentSlide].title}</h4>
                  <p className="text-base text-gray-200">{images[currentSlide].description}</p>
                </div>
              </div>
            )}

            {/* 이전/다음 버튼 */}
            <button
              onClick={prevSlide}
              className="absolute left-2 md:left-4 top-1/2 transform -translate-y-1/2 bg-white/80 hover:bg-white text-primary rounded-full p-3 shadow-lg transition-all duration-200 hover:scale-110 z-10"
              type="button"
            >
              <svg className="w-5 h-5 md:w-6 md:h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
              </svg>
            </button>
            
            <button
              onClick={nextSlide}
              className="absolute right-2 md:right-4 top-1/2 transform -translate-y-1/2 bg-white/80 hover:bg-white text-primary rounded-full p-3 shadow-lg transition-all duration-200 hover:scale-110 z-10"
              type="button"
            >
              <svg className="w-5 h-5 md:w-6 md:h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
              </svg>
            </button>
          </div>
        </div>

        {/* 모바일에서만 이미지 설명 표시 */}
        {showDescription && images[currentSlide].title && (
          <div className="block md:hidden mt-4 p-4 bg-gray-50 rounded-lg">
            <h4 className="text-lg font-bold text-primary mb-2">{images[currentSlide].title}</h4>
            <p className="text-sm text-gray-700">{images[currentSlide].description}</p>
          </div>
        )}

        {/* 썸네일 (데스크톱 전용) */}
        {showThumbnails && (
          <div className="hidden md:block mt-6">
            <div 
              ref={thumbnailContainerRef}
              className="flex justify-center space-x-3 overflow-x-auto scrollbar-hide"
            >
              {images.map((image, index) => (
                <button
                  key={`${title}-thumbnail-${index}`}
                  data-thumbnail-index={`${title}-${index}`}
                  onClick={() => goToSlide(index)}
                  className={`relative flex-shrink-0 w-16 h-10 rounded-lg overflow-hidden border-2 transition-all duration-200 ${
                    currentSlide === index
                      ? 'border-primary shadow-lg ring-2 ring-primary/30'
                      : 'border-gray-300 hover:border-primary/50 opacity-70 hover:opacity-100'
                  }`}
                >
                  <img
                    src={image.thumb || image.src}
                    alt={`${title} 썸네일 ${index + 1}`}
                    className="w-full h-full object-cover"
                    draggable={false}
                    loading="lazy"
                  />
                  {currentSlide === index && (
                    <div className="absolute inset-0 bg-primary/20 rounded-lg" />
                  )}
                </button>
              ))}
            </div>
          </div>
        )}

        {/* 인디케이터와 슬라이드 정보 */}
        <div className="text-center mt-6 space-y-4">
          {/* 인디케이터 (병원 시설만) */}
          {showThumbnails && (
            <div className="flex justify-center space-x-2">
              {images.map((_, index) => (
                <button
                  key={index}
                  onClick={() => goToSlide(index)}
                  className={`w-3 h-3 md:w-4 md:h-4 rounded-full transition-colors duration-200 ${
                    currentSlide === index ? 'bg-primary' : 'bg-gray-300 hover:bg-primary/50'
                  }`}
                />
              ))}
            </div>
          )}
          
          {/* 슬라이드 번호 */}
          <div className="text-sm text-gray-500">
            {currentSlide + 1} / {images.length}
          </div>
        </div>
      </div>
    </div>
  );
};

const ClinicIntroPage = () => {
  // URL 파라미터에서 초기 탭 설정 (깜빡임 방지)
  const location = useLocation();
  const navigate = useNavigate();
  
  const getInitialTab = () => {
    const urlParams = new URLSearchParams(location.search);
    const tabParam = urlParams.get('tab');
    return tabParam || 'intro'; // 기본값: 'intro'
  };

  const [activeTab, setActiveTab] = useState(getInitialTab);
  const [facilitySlide, setFacilitySlide] = useState(0);
  const [generalSlide, setGeneralSlide] = useState(0);
  const [hospitalStorySlide, setHospitalStorySlide] = useState(0);
  const heroRef = useRef(null);

  // URL 변경 시 탭 상태 업데이트
  useEffect(() => {
    const urlParams = new URLSearchParams(location.search);
    const tabParam = urlParams.get('tab');
    const newTab = tabParam || 'intro';
    setActiveTab(newTab);
  }, [location.search]);

  useEffect(() => {
    // fullPage.js 제거 (혹시 남아있을 경우)
    if (window.$ && window.$.fn && window.$.fn.fullpage && window.$.fn.fullpage.destroy) {
      window.$.fn.fullpage.destroy('all');
    }
    
    // body에서 fullpage-enabled 클래스 제거
    document.body.classList.remove('fullpage-enabled');
    
    // 일반 스크롤 복원을 위한 스타일 추가
    document.body.style.overflow = '';
    document.documentElement.style.overflow = '';
    
    // cleanup
    return () => {
      document.body.style.overflow = '';
      document.documentElement.style.overflow = '';
    };
  }, []);

  // activeTab이 변경될 때마다 페이지를 맨 위로 스크롤
  useEffect(() => {
    // DOM 업데이트 후 스크롤하도록 지연
    const timer = setTimeout(() => {
      if (heroRef.current) {
        heroRef.current.scrollIntoView({
          behavior: 'auto',
          block: 'start'
        });
      } else {
        window.scrollTo({
          top: 0,
          behavior: 'auto'
        });
      }
    }, 100); // 지연 시간을 늘려서 슬라이더 초기화 후 스크롤

    return () => clearTimeout(timer);
  }, [activeTab]);

  // 탭이 변경될 때 슬라이드 초기화 (스크롤보다 먼저 실행)
  useEffect(() => {
    setFacilitySlide(0);
    setGeneralSlide(0);
    setHospitalStorySlide(0);
  }, [activeTab]);

  // 병원 이야기 이미지 데이터
  const facilityImages = [
    {
      id: 1,
      src: '/assets/병원 이야기/병원 시설/대기실.webp',

      thumb: '/assets/병원 이야기/병원 시설/대기실.thumb.webp',
      title: '따뜻한 대기실',
      description: '환자분들이 편안하게 기다리실 수 있는 아늑한 대기실입니다.'
    },
    {
      id: 2,
      src: '/assets/병원 이야기/병원 시설/대기실2.webp',

      thumb: '/assets/병원 이야기/병원 시설/대기실2.thumb.webp',
      title: '편안한 대기 공간',
      description: '가족 단위로 편안하게 대기하실 수 있는 넓은 공간을 제공합니다.'
    },
    {
      id: 3,
      src: '/assets/병원 이야기/병원 시설/대기실3.webp',

      thumb: '/assets/병원 이야기/병원 시설/대기실3.thumb.webp',
      title: '밝고 쾌적한 환경',
      description: '자연광이 들어오는 밝고 쾌적한 대기실 환경입니다.'
    },
    {
      id: 4,
      src: '/assets/병원 이야기/병원 시설/큰체어.webp',

      thumb: '/assets/병원 이야기/병원 시설/큰체어.thumb.webp',
      title: '최신 진료 장비',
      description: '환자분들께 최고의 치료를 제공하기 위한 첨단 장비를 갖추고 있습니다.'
    },
    {
      id: 5,
      src: '/assets/병원 이야기/병원 시설/상담실.webp',

      thumb: '/assets/병원 이야기/병원 시설/상담실.thumb.webp',
      title: '상담실',
      description: '환자분들의 고민을 편안하게 나눌 수 있는 아늑한 상담 공간입니다.'
    },
    {
      id: 6,
      src: '/assets/병원 이야기/병원 시설/진료실.webp',

      thumb: '/assets/병원 이야기/병원 시설/진료실.thumb.webp',
      title: '쾌적한 진료실',
      description: '최신 장비와 청결한 환경에서 안전하게 진료를 받으실 수 있습니다.'
    },
    {
      id: 7,
      src: '/assets/병원 이야기/병원 시설/수술실.webp',

      thumb: '/assets/병원 이야기/병원 시설/수술실.thumb.webp',
      title: '멸균된 수술실',
      description: '안전하고 청결한 환경에서 모든 치료가 이루어집니다.'
    },
    {
      id: 8,
      src: '/assets/병원 이야기/병원 시설/세면대.webp',

      thumb: '/assets/병원 이야기/병원 시설/세면대.thumb.webp',
      title: '위생적인 세면 공간',
      description: '치료 전후 깔끔하게 정리하실 수 있는 세면 공간입니다.'
    },
    {
      id: 9,
      src: '/assets/병원 이야기/병원 시설/약력&위촉.webp',

      thumb: '/assets/병원 이야기/병원 시설/약력&위촉.thumb.webp',
      title: '전문성 인증',
      description: '지속적인 학습과 연구로 전문성을 인정받고 있습니다.'
    }
  ];

  // 일반 사진 추가
  const generalImages = [
    { id: 1, src: '/assets/병원 이야기/일반사진_압축/20.webp' },
    { id: 2, src: '/assets/병원 이야기/일반사진_압축/1.webp' },
    { id: 3, src: '/assets/병원 이야기/일반사진_압축/2.webp' },
    { id: 4, src: '/assets/병원 이야기/일반사진_압축/3.webp' },
    { id: 5, src: '/assets/병원 이야기/일반사진_압축/5.webp' },
    { id: 6, src: '/assets/병원 이야기/일반사진_압축/6.webp' },  
    { id: 7, src: '/assets/병원 이야기/일반사진_압축/7.webp' },
    { id: 8, src: '/assets/병원 이야기/일반사진_압축/9.webp' },
    { id: 9, src: '/assets/병원 이야기/일반사진_압축/10.webp' },
    { id: 10, src: '/assets/병원 이야기/일반사진_압축/11.webp' },
    { id: 11, src: '/assets/병원 이야기/일반사진_압축/12.webp' },
    { id: 12, src: '/assets/병원 이야기/일반사진_압축/13.webp' },
    { id: 13, src: '/assets/병원 이야기/일반사진_압축/14.webp' },
    { id: 14, src: '/assets/병원 이야기/일반사진_압축/15.webp' },
    { id: 15, src: '/assets/병원 이야기/일반사진_압축/16.webp' },
    { id: 16, src: '/assets/병원 이야기/일반사진_압축/17.webp' },
    { id: 17, src: '/assets/병원 이야기/일반사진_압축/18.webp' },
    { id: 18, src: '/assets/병원 이야기/일반사진_압축/19.webp' },
    { id: 19, src: '/assets/병원 이야기/일반사진_압축/21.webp' },
    { id: 20, src: '/assets/병원 이야기/일반사진_압축/22.webp' },
    { id: 21, src: '/assets/병원 이야기/일반사진_압축/23.webp' },
    { id: 22, src: '/assets/병원 이야기/일반사진_압축/24.webp' },
    { id: 23, src: '/assets/병원 이야기/일반사진_압축/25.webp' },
    { id: 24, src: '/assets/병원 이야기/일반사진_압축/26.webp' },
    { id: 25, src: '/assets/병원 이야기/일반사진_압축/27.webp' }
  ];

  // 환자분들이 주신 선물과 직원분들께 주는 선물을 섞어서 보여주는 병원이야기 이미지들
  const hospitalStoryImages = [
    { id: 1, src: '/assets/병원 이야기/직원분들께 주는 선물_압축/26-1.webp' },
    { id: 2, src: '/assets/병원 이야기/직원분들께 주는 선물_압축/26-2.webp' },
    { id: 3, src: '/assets/병원 이야기/직원분들께 주는 선물_압축/26-3.webp' },
    { id: 4, src: '/assets/병원 이야기/직원분들께 주는 선물_압축/26-4.webp' },
    { id: 5, src: '/assets/병원 이야기/직원분들께 주는 선물_압축/26-5.webp' },
    { id: 6, src: '/assets/병원 이야기/환자분들이 주신 선물_압축/12.webp' },
    { id: 7, src: '/assets/병원 이야기/직원분들께 주는 선물_압축/1.webp' },
    { id: 8, src: '/assets/병원 이야기/환자분들이 주신 선물_압축/2.webp' },
    { id: 9, src: '/assets/병원 이야기/환자분들이 주신 선물_압축/3.webp' },
    { id: 10, src: '/assets/병원 이야기/직원분들께 주는 선물_압축/3.webp' },
    { id: 11, src: '/assets/병원 이야기/환자분들이 주신 선물_압축/4.webp' },
    { id: 12, src: '/assets/병원 이야기/직원분들께 주는 선물_압축/4.webp' },
    { id: 13, src: '/assets/병원 이야기/직원분들께 주는 선물_압축/5.webp' },
    { id: 14, src: '/assets/병원 이야기/환자분들이 주신 선물_압축/6.webp' },
    { id: 15, src: '/assets/병원 이야기/직원분들께 주는 선물_압축/6.webp' },
    { id: 16, src: '/assets/병원 이야기/환자분들이 주신 선물_압축/7.webp' },
    { id: 17, src: '/assets/병원 이야기/직원분들께 주는 선물_압축/7.webp' },
    { id: 18, src: '/assets/병원 이야기/환자분들이 주신 선물_압축/8.webp' },
    { id: 19, src: '/assets/병원 이야기/직원분들께 주는 선물_압축/8.webp' },
    { id: 20, src: '/assets/병원 이야기/환자분들이 주신 선물_압축/9.webp' },
    { id: 21, src: '/assets/병원 이야기/직원분들께 주는 선물_압축/9.webp' },
    { id: 22, src: '/assets/병원 이야기/환자분들이 주신 선물_압축/10.webp' },
    { id: 23, src: '/assets/병원 이야기/직원분들께 주는 선물_압축/10.webp' },
    { id: 24, src: '/assets/병원 이야기/환자분들이 주신 선물_압축/11.webp' },
    { id: 25, src: '/assets/병원 이야기/직원분들께 주는 선물_압축/11.webp' },
    { id: 26, src: '/assets/병원 이야기/환자분들이 주신 선물_압축/1.webp' },
    { id: 27, src: '/assets/병원 이야기/환자분들이 주신 선물_압축/13.webp' },
    { id: 28, src: '/assets/병원 이야기/직원분들께 주는 선물_압축/12.webp' },
    { id: 29, src: '/assets/병원 이야기/직원분들께 주는 선물_압축/13.webp' },
    { id: 30, src: '/assets/병원 이야기/환자분들이 주신 선물_압축/14.webp' },
    { id: 31, src: '/assets/병원 이야기/환자분들이 주신 선물_압축/15.webp' },
    { id: 32, src: '/assets/병원 이야기/직원분들께 주는 선물_압축/14.webp' },
    { id: 33, src: '/assets/병원 이야기/환자분들이 주신 선물_압축/16.webp' },
    { id: 34, src: '/assets/병원 이야기/환자분들이 주신 선물_압축/17.webp' },
    { id: 35, src: '/assets/병원 이야기/직원분들께 주는 선물_압축/15.webp' },
    { id: 36, src: '/assets/병원 이야기/직원분들께 주는 선물_압축/16.webp' },
    { id: 37, src: '/assets/병원 이야기/직원분들께 주는 선물_압축/17.webp' },
    { id: 38, src: '/assets/병원 이야기/직원분들께 주는 선물_압축/18.webp' },
    { id: 39, src: '/assets/병원 이야기/직원분들께 주는 선물_압축/19.webp' },
    { id: 40, src: '/assets/병원 이야기/환자분들이 주신 선물_압축/18.webp' },
  ];

  const tabs = [
    { id: 'intro', name: '인사말', shortName: '인사말' },
    { id: 'doctors', name: '의료진', shortName: '의료진' },
    { id: 'story', name: '병원 이야기', shortName: '이야기' },
    { id: 'hours', name: '진료시간', shortName: '시간' },
    { id: 'location', name: '오시는 길', shortName: '위치' },
  ];

  // 탭 변경 핸들러 (URL도 함께 업데이트)
  const handleTabChange = (tabId) => {
    setActiveTab(tabId);
    navigate(`/clinic-intro?tab=${tabId}`, { replace: true });
  };

  const renderIntroContent = () => (
    <div className="space-y-8 md:space-y-16">
      {/* 원장 인사말 메인 섹션 */}
      <div className="text-center mb-6 md:mb-12">
        <h2 className="text-2xl md:text-4xl font-bold text-primary mb-2 md:mb-4">원장 인사말</h2>
        <p className="text-base md:text-xl text-gray-600">{YEARS_SINCE_OPENING}년간 충북혁신도시 지역민들과 함께한 시간</p>
      </div>

      {/* 2019년 개원 당시 인사말 */}
      <div className="bg-gradient-to-r from-blue-50 to-purple-50 rounded-2xl md:rounded-3xl p-4 md:p-10 shadow-lg">
        <div className="grid lg:grid-cols-2 gap-6 md:gap-12 items-center">
          <div className="order-2 lg:order-1">
            <div className="bg-white rounded-xl md:rounded-2xl p-4 md:p-8 shadow-md">
              <div className="flex items-center mb-4 md:mb-6">
                <div className="w-10 h-10 md:w-12 md:h-12 bg-primary rounded-full flex items-center justify-center mr-3 md:mr-4">
                  <span className="text-white font-bold text-sm md:text-base">2019</span>
                </div>
                <h3 className="text-lg md:text-2xl font-bold text-primary">개원 당시의 다짐</h3>
              </div>
              
              <div className="text-sm md:text-lg text-gray-700 leading-relaxed space-y-3 md:space-y-4">
                <p>안녕하세요.</p>
                <p><strong className="text-primary">한앤손 부부치과 대표원장 한지은, 손용준</strong>입니다.</p>
                <p>
                  충북혁신도시는 저희를 포함하여 외조부모님과 슬하 여덟 남매의 가족들이 같이 살아가고 있는 곳입니다.
                </p>
                <p>
                  우리네 부모님의 고향에서 나의 가족들을 모시는 마음으로 정성어린 진료를 시작하고자 합니다.
                </p>
                <p className="text-primary font-semibold italic">
                  "환자 한분 한분 저희 병원에서 몸과 마음이 치유되실 수 있도록 최선을 다하겠습니다."
                </p>
              </div>
            </div>
          </div>
          
          <div className="order-1 lg:order-2">
            <div className="relative">
              <img 
                src="/assets/2019_부부같이사진.webp" 
                alt="2019년 개원 당시 한지은, 손용준 원장님" 
                className="w-full max-w-sm md:max-w-md mx-auto rounded-xl md:rounded-2xl shadow-lg"
                loading="lazy"
              />
              <div className="absolute -bottom-2 -right-2 md:-bottom-4 md:-right-4 bg-white rounded-lg p-2 md:p-3 shadow-lg">
                <p className="text-xs md:text-sm font-semibold text-gray-600">2019년 개원</p>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* 현재 */}
      <div className="bg-gradient-to-r from-green-50 to-blue-50 rounded-2xl md:rounded-3xl p-4 md:p-10 shadow-lg">
        <div className="grid lg:grid-cols-2 gap-6 md:gap-12 items-center">
          <div>
            <div className="relative">
              <img 
                src="/assets/2025_부부같이사진.webp" 
                alt="현재의 한지은, 손용준 원장님" 
                className="w-full max-w-sm md:max-w-md mx-auto rounded-xl md:rounded-2xl shadow-lg"
                loading="lazy"
              />
              <div className="absolute -bottom-2 -left-2 md:-bottom-4 md:-left-4 bg-white rounded-lg p-2 md:p-3 shadow-lg">
                <p className="text-xs md:text-sm font-semibold text-gray-600">{CURRENT_YEAR}년 현재</p>
              </div>
            </div>
          </div>
          
          <div>
            <div className="bg-white rounded-xl md:rounded-2xl p-4 md:p-8 shadow-md">
              <div className="flex items-center mb-4 md:mb-6">
                <div className="w-10 h-10 md:w-12 md:h-12 bg-secondary rounded-full flex items-center justify-center mr-3 md:mr-4">
                  <span className="text-white font-bold text-sm md:text-base">{CURRENT_YEAR}</span>
                </div>
                <h3 className="text-lg md:text-2xl font-bold text-secondary">{YEARS_SINCE_OPENING}년간의 여정과 앞으로의 약속</h3>
              </div>
              
              <div className="text-sm md:text-lg text-gray-700 leading-relaxed space-y-3 md:space-y-4">
                <p>
                  안녕하세요,<br/>
                  <strong className="text-secondary">한앤손부부치과 대표원장 한지은, 손용준</strong>입니다.
                </p>
                <p>
                  <strong className="text-secondary">2019년 푸릇푸릇한 나뭇잎 사이로 햇살과 바람이 살랑이던 5월</strong>, 
                  첫 진료를 시작했던 날의 설렘과 두근거림을 기억합니다.
                </p>
                <p>
                  매순간 정직한 마음으로 진료에 임하며 어느덧 <strong className="text-secondary">{YEARS_SINCE_OPENING}년이란 시간</strong>이 흘렀고,
                  수많은 환자분들과의 만남을 통해 저희도 함께 성장해왔습니다.
                </p>
                <p>
                  충북혁신도시란 작은 도시가 점점 발전을 하며 인구가 늘어나고,
                  병원에 오시는 환자분들의 가족 수가 늘어나고, 또 아이들이 성장하는 모습을 지켜보면서
                  <strong className="text-secondary"> 가슴 벅참을 느끼는 순간</strong>이 많았습니다.
                </p>
                <p>
                  치료는 <strong className="text-secondary">경험이 묻어나고 진심이 더해질 때</strong> 그 가치와 결과가 더욱 좋을 수 밖에 없다고 믿고 있습니다.
                </p>
                <p>
                  내가 이 곳의 지역주민으로서, 
                  내가 자식의 마음으로, 또 부모로서 아이를 사랑하는 마음이 더해질 때
                  <strong className="text-secondary"> 더 좋은 진료가 이루어진다는 믿음</strong>으로 진료해왔습니다.
                </p>
                <p>
                  별다른 광고 한번 한적 없음에도 저희를 믿고 발걸음해주시는 <strong className="text-secondary">환자분들께 감사한 마음</strong>을 전하며,
                  앞으로도 충북혁신도시 환자분들의 <strong className="text-secondary">치과 주치의</strong>로서 최선을 다하겠습니다.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* 한앤손 부부치과 소개 */}
      <div className="bg-gradient-to-r from-purple-50 to-pink-50 rounded-2xl md:rounded-3xl p-4 md:p-10 shadow-lg">
        <div className="text-center mb-6 md:mb-10">
          <div className="mx-auto w-20 h-20 md:w-32 md:h-32 mb-4 md:mb-6 flex items-center justify-center">
            <img 
              src="/assets/한앤손부부치과_로고.webp" 
              alt="한앤손 부부치과 로고" 
              className="max-w-full max-h-full object-contain"
            />
          </div>
          <h3 className="text-xl md:text-3xl font-bold text-primary mb-2 md:mb-4">한앤손 부부치과</h3>
          <p className="text-base md:text-xl text-gray-600">정확한 진단과 섬세한 치료로 함께합니다</p>
        </div>
        
        <div className="max-w-4xl mx-auto space-y-4 md:space-y-8">
          <div className="grid md:grid-cols-2 gap-4 md:gap-8">
            <div className="bg-blue-50 rounded-xl md:rounded-2xl p-4 md:p-6">
              <div className="flex items-center mb-3 md:mb-4">
                <div className="w-8 h-8 md:w-10 md:h-10 bg-primary rounded-full flex items-center justify-center mr-2 md:mr-3">
                  <svg className="w-4 h-4 md:w-5 md:h-5 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z" />
                  </svg>
                </div>
                <h4 className="text-sm md:text-lg font-semibold text-primary">부부 원장 시스템</h4>
              </div>
              <p className="text-xs md:text-base text-gray-700">
                부부 원장이 직접 환자를 처음부터 끝까지 책임지고 진료하는 것을 원칙으로 합니다.
              </p>
            </div>
            
            <div className="bg-orange-50 rounded-xl md:rounded-2xl p-4 md:p-6">
              <div className="flex items-center mb-3 md:mb-4">
                <div className="w-8 h-8 md:w-10 md:h-10 bg-orange-500 rounded-full flex items-center justify-center mr-2 md:mr-3">
                  <svg className="w-4 h-4 md:w-5 md:h-5 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4.318 6.318a4.5 4.5 0 000 6.364L12 20.364l7.682-7.682a4.5 4.5 0 00-6.364-6.364L12 7.636l-1.318-1.318a4.5 4.5 0 00-6.364 0z" />
                  </svg>
                </div>
                <h4 className="text-sm md:text-lg font-semibold text-orange-600">가족 같은 마음</h4>
              </div>
              <p className="text-xs md:text-base text-gray-700">
                불필요한 치료보다는 환자의 구강 건강을 위한 최선의 치료법을 제안하고, 
                모든 환자분들께 가족과 같은 마음으로 정성을 다해 진료합니다.
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* 진료 철학 섹션 */}
      <div className="bg-gradient-to-r from-indigo-50 to-blue-50 rounded-2xl md:rounded-3xl p-4 md:p-10 shadow-lg">
        <div className="text-center mb-6 md:mb-10">
          <h3 className="text-xl md:text-3xl font-bold text-primary mb-2 md:mb-4">한앤손 부부치과의 진료 철학</h3>
          <p className="text-sm md:text-lg text-gray-600">{YEARS_SINCE_OPENING}년간 변하지 않은 저희의 신념입니다</p>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-8 max-w-6xl mx-auto">
          <div className="bg-white rounded-xl md:rounded-2xl p-4 md:p-8 text-center shadow-lg hover:shadow-xl transition-shadow duration-300">
            <div className="w-12 h-12 md:w-20 md:h-20 bg-gradient-to-br from-blue-500 to-blue-600 rounded-full flex items-center justify-center mx-auto mb-3 md:mb-6">
              <svg className="w-6 h-6 md:w-10 md:h-10 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4.318 6.318a4.5 4.5 0 000 6.364L12 20.364l7.682-7.682a4.5 4.5 0 00-6.364-6.364L12 7.636l-1.318-1.318a4.5 4.5 0 00-6.364 0z" />
              </svg>
            </div>
            <h4 className="text-sm md:text-xl font-bold text-primary mb-2 md:mb-4">마음을 공감합니다</h4>
            <p className="text-xs md:text-base text-gray-600 leading-relaxed">
              치료의 시작은 공감입니다. 환자의 마음을 이해하고 
              소통하는 열린 마음으로 진료를 시작합니다.
            </p>
          </div>

          <div className="bg-white rounded-xl md:rounded-2xl p-4 md:p-8 text-center shadow-lg hover:shadow-xl transition-shadow duration-300">
            <div className="w-12 h-12 md:w-20 md:h-20 bg-gradient-to-br from-green-500 to-green-600 rounded-full flex items-center justify-center mx-auto mb-3 md:mb-6">
              <svg className="w-6 h-6 md:w-10 md:h-10 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
              </svg>
            </div>
            <h4 className="text-sm md:text-xl font-bold text-primary mb-2 md:mb-4">정확한 진단과 섬세한 치료</h4>
            <p className="text-xs md:text-base text-gray-600 leading-relaxed">
              {YEARS_SINCE_OPENING}년간 쌓은 풍부한 임상 경험과 첨단 장비를 바탕으로 
              정확한 진단과 섬세한 치료를 제공합니다.
            </p>
          </div>

          <div className="bg-white rounded-xl md:rounded-2xl p-4 md:p-8 text-center shadow-lg hover:shadow-xl transition-shadow duration-300">
            <div className="w-12 h-12 md:w-20 md:h-20 bg-gradient-to-br from-purple-500 to-purple-600 rounded-full flex items-center justify-center mx-auto mb-3 md:mb-6">
              <svg className="w-6 h-6 md:w-10 md:h-10 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z" />
              </svg>
            </div>
            <h4 className="text-sm md:text-xl font-bold text-primary mb-2 md:mb-4">평생 주치의</h4>
            <p className="text-xs md:text-base text-gray-600 leading-relaxed">
              한 번 맺은 인연, 오랫동안 지켜드립니다. 
              처음부터 끝까지 한 의사가 책임지고 진료합니다.
            </p>
          </div>
        </div>
      </div>
    </div>
  );

  const renderDoctorsContent = () => (
    <div className="space-y-12">
      {/* 의료진 소개 섹션 */}
      <div className="text-center mb-12">
        <h2 className="text-3xl md:text-4xl font-bold text-primary mb-6">믿을 수 있는 의료진</h2>
        <div className="max-w-4xl mx-auto">
          <p className="text-lg md:text-xl text-gray-600 mb-8 leading-relaxed">
            <strong className="text-primary">충북혁신도시와 함께해온 신뢰의 경험</strong>과 <strong className="text-secondary">풍부한 임상 실력</strong>을 바탕으로<br />
            환자 한 분 한 분께 최선의 치료를 제공합니다.
          </p>
          
          <div className="p-6 bg-gradient-to-r from-gray-50 to-blue-50 rounded-xl">
            <p className="text-primary font-semibold text-lg italic">
              "환자분의 소중한 치아를 내 가족의 치아처럼 정성껏 치료합니다"
            </p>
          </div>
        </div>
      </div>

      <div className="grid gap-12 md:grid-cols-2">
        {doctors.map((doctor, index) => (
          <div
            key={index}
            className="bg-white rounded-xl shadow-lg hover:shadow-xl transition-all duration-300 p-8 flex flex-col items-center text-center"
          >
            <div className="overflow-hidden rounded-xl shadow-md w-full max-w-xs mb-6 transform hover:scale-105 transition-transform">
              <img src={doctor.image} alt={doctor.name} className="w-full h-auto object-cover" loading="lazy" />
            </div>
            <h2 className="text-2xl font-semibold text-primary mb-2">{doctor.name}</h2>
            <p className="text-gray-500 mb-6 text-lg">{doctor.title}</p>
            <div className="bg-blue-50 rounded-lg p-6 w-full text-left">
              <h4 className="text-lg font-semibold text-primary mb-4">약력</h4>
              <ul className="list-disc list-inside text-base text-gray-700 space-y-2">
                {doctor.profile.map((item, idx) => (
                  <li key={idx}>{item}</li>
                ))}
              </ul>
            </div>
          </div>
        ))}
      </div>
    </div>
  );

  const renderHoursContent = () => (
    <div className="max-w-2xl mx-auto">
      <div className="bg-white rounded-xl shadow-lg p-8">
        <h3 className="text-2xl font-semibold text-primary mb-6 text-center">진료 시간</h3>
        <div className="space-y-3">
          <div className="flex justify-between items-center py-4 border-b border-gray-200">
            <div className="font-medium text-gray-800 text-lg">평일</div>
            <div className="text-gray-600 text-lg">AM 9:00 - PM 6:00</div>
          </div>
          <div className="flex justify-between items-center py-4 border-b border-gray-200 bg-gradient-to-r from-blue-50 to-primary/10 -mx-4 px-4 rounded-lg">
            <div className="font-medium text-gray-800 text-lg">화요일</div>
            <div className="text-gray-600 text-lg">
              AM 9:00 - PM 8:00 
              <span className="text-sm text-white ml-3 bg-primary px-3 py-1 rounded-full font-medium">야간진료</span>
            </div>
          </div>
          <div className="flex justify-between items-center py-4 border-b border-gray-200">
            <div className="font-medium text-gray-800 text-lg">토요일</div>
            <div className="text-gray-600 text-lg">AM 9:00 - PM 1:00</div>
          </div>
          <div className="flex justify-between items-center py-4 border-b border-gray-200">
            <div className="font-medium text-gray-800 text-lg">일요일 · 공휴일</div>
            <div className="text-red-500 font-medium text-lg">휴진</div>
          </div>
          <div className="flex justify-between items-center py-4 bg-yellow-50 -mx-4 px-4 rounded-lg">
            <div className="font-medium text-gray-800 text-lg">점심시간</div>
            <div className="text-gray-600 text-lg">12:30-14:00</div>
          </div>
        </div>
        
        <div className="mt-8 p-6 bg-gradient-to-r from-blue-50 to-primary/10 rounded-lg text-center">
          <p className="text-xl font-medium text-primary mb-3">예약 문의</p>
          <div className="flex items-center justify-center">
            <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 text-primary mr-3" viewBox="0 0 20 20" fill="currentColor">
              <path d="M2 3a1 1 0 011-1h2.153a1 1 0 01.986.836l.74 4.435a1 1 0 01-.54 1.06l-1.548.773a11.037 11.037 0 006.105 6.105l.774-1.548a1 1 0 011.059-.54l4.435.74a1 1 0 01.836.986V17a1 1 0 01-1 1h-2C7.82 18 2 12.18 2 5V3z" />
            </svg>
            <a href="tel:043-534-3434" className="text-xl text-primary hover:underline font-bold">043-534-3434</a>
          </div>
        </div>
      </div>
    </div>
  );

  const renderLocationContent = () => (
    <div className="max-w-4xl mx-auto space-y-8">
      <div className="bg-white rounded-xl shadow-lg p-8">
        <h3 className="text-2xl font-semibold text-primary mb-8 text-center">오시는 길</h3>
        
        <div className="grid md:grid-cols-2 gap-10">
          <div>
            <h4 className="text-xl font-semibold text-gray-800 mb-6">주소 정보</h4>
            <div className="space-y-5">
              <div className="flex items-start">
                <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 text-primary mr-4 mt-1 flex-shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
                </svg>
                <div>
                  <p className="font-semibold text-gray-800 text-lg">충청북도 진천군 덕산읍 공원로 4 3층</p>
                  <p className="text-gray-600 mt-1">한앤손부부치과</p>
                </div>
              </div>
              
              <div className="flex items-center">
                <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 text-primary mr-4 flex-shrink-0" viewBox="0 0 20 20" fill="currentColor">
                  <path d="M2 3a1 1 0 011-1h2.153a1 1 0 01.986.836l.74 4.435a1 1 0 01-.54 1.06l-1.548.773a11.037 11.037 0 006.105 6.105l.774-1.548a1 1 0 011.059-.54l4.435.74a1 1 0 01.836.986V17a1 1 0 01-1 1h-2C7.82 18 2 12.18 2 5V3z" />
                </svg>
                <a href="tel:043-534-3434" className="text-primary hover:underline font-semibold text-lg">043-534-3434</a>
              </div>
            </div>

            <div className="mt-8 p-4 bg-blue-50 rounded-lg">
              <h5 className="font-semibold text-gray-800 mb-4 text-lg">교통편</h5>
              <ul className="text-gray-700 space-y-2">
                <li className="flex items-center">
                  <span className="w-2 h-2 bg-primary rounded-full mr-3"></span>
                  주차 공간 완비
                </li>
                <li className="flex items-center">
                  <span className="w-2 h-2 bg-primary rounded-full mr-3"></span>
                  대중교통 이용 가능
                </li>
                <li className="flex items-center">
                  <span className="w-2 h-2 bg-primary rounded-full mr-3"></span>
                  덕산읍 중심가 위치
                </li>
              </ul>
            </div>
          </div>

          <div>
            <h4 className="text-xl font-semibold text-gray-800 mb-6">지도</h4>
            <div className="bg-gray-200 rounded-lg h-80 overflow-hidden shadow-md">
              <KakaoMap />
            </div>
          </div>
        </div>
      </div>
    </div>
  );

  const renderStoryContent = () => {
    return (
      <div className="space-y-10 md:space-y-16">
        {/* 병원 이야기 소개 */}
        <div className="text-center mb-8 md:mb-12">
          <h2 className="text-2xl md:text-4xl font-bold text-primary mb-4">병원 이야기</h2>
          <p className="text-base md:text-xl text-gray-600 max-w-3xl mx-auto leading-relaxed">
            {YEARS_SINCE_OPENING}년간 함께해온 소중한 순간들과 환자분들, 직원분들과의 따뜻한 추억들을<br/>
            세 가지 이야기로 나누어 소개합니다.
          </p>
        </div>

        {/* 병원 시설 */}
        <ImageSlider 
          images={facilityImages}
          currentSlide={facilitySlide}
          setCurrentSlide={setFacilitySlide}
          showDescription={true}
          title="병원 시설"
          isSquareRatio={false}
          showThumbnails={true}
        />

        {/* 병원 사진 */}
        <ImageSlider 
          images={generalImages}
          currentSlide={generalSlide}
          setCurrentSlide={setGeneralSlide}
          showDescription={false}
          title="병원 사진"
          isSquareRatio={true}
        />

        {/* 병원이야기 (환자분들이 주신 선물 + 직원분들께 주는 선물) */}
        <ImageSlider 
          images={hospitalStoryImages}
          currentSlide={hospitalStorySlide}
          setCurrentSlide={setHospitalStorySlide}
          showDescription={false}
          title="병원이야기"
          isSquareRatio={true}
        />

        {/* 메시지 섹션 */}
        <div className="bg-gradient-to-r from-purple-50 to-pink-50 rounded-2xl md:rounded-3xl p-4 md:p-10 shadow-lg text-center">
          <div className="max-w-3xl mx-auto">
            <h3 className="text-xl md:text-3xl font-bold text-primary mb-4 md:mb-6">함께 만들어가는 이야기</h3>
            <p className="text-sm md:text-lg text-gray-700 leading-relaxed mb-6 md:mb-8">
              환자분들과 직원분들과 함께 만들어가는 소중한 순간들이 저희 병원의 가장 큰 자산입니다.<br/>
              서로에게 전하는 감사와 사랑이 담긴 따뜻한 "병원이야기"들을 함께 나누고 있습니다.
            </p>
            <div className="flex items-center justify-center space-x-4">
              <div className="flex items-center text-primary">
                <svg className="w-5 h-5 md:w-6 md:h-6 mr-2" fill="currentColor" viewBox="0 0 20 20">
                  <path fillRule="evenodd" d="M3.172 5.172a4 4 0 015.656 0L10 6.343l1.172-1.171a4 4 0 115.656 5.656L10 17.657l-6.828-6.829a4 4 0 010-5.656z" clipRule="evenodd" />
                </svg>
                <span className="text-sm md:text-base font-medium">환자분들의 사랑</span>
              </div>
              <div className="w-px h-6 bg-gray-300"></div>
              <div className="flex items-center text-secondary">
                <svg className="w-5 h-5 md:w-6 md:h-6 mr-2" fill="currentColor" viewBox="0 0 20 20">
                  <path d="M13 6a3 3 0 11-6 0 3 3 0 016 0zM18 8a2 2 0 11-4 0 2 2 0 014 0zM14 15a4 4 0 00-8 0v3h8v-3zM6 8a2 2 0 11-4 0 2 2 0 014 0zM16 18v-3a5.972 5.972 0 00-.75-2.906A3.005 3.005 0 0119 15v3h-3zM4.75 12.094A5.973 5.973 0 004 15v3H1v-3a3 3 0 013.75-2.906z" />
                </svg>
                <span className="text-sm md:text-base font-medium">직원분들과의 동행</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  };

  const renderTabContent = () => {
    switch (activeTab) {
      case 'intro':
        return renderIntroContent();
      case 'doctors':
        return renderDoctorsContent();
      case 'story':
        return renderStoryContent();
      case 'hours':
        return renderHoursContent();
      case 'location':
        return renderLocationContent();
      default:
        return renderIntroContent();
    }
  };

  return (
    <div className="clinic-intro-page-container">
      {/* 히어로 섹션 */}
      <HeroSection 
        title="치과소개"
        backgroundImage="/assets/치과소개_대기실.jpg"
        brandText="한앤손 부부치과"
        ref={heroRef}
      >
        {/* 탭 네비게이션 */}
        <div className="flex justify-center">
          <div className="bg-white/20 backdrop-blur-md rounded-2xl p-1 inline-flex max-w-full border border-white/30">
            <div className="flex space-x-1 overflow-x-auto scrollbar-hide">
              {tabs.map((tab) => (
                <button
                  key={tab.id}
                  onClick={() => handleTabChange(tab.id)}
                  className={`px-2.5 md:px-4 py-2 rounded-xl text-sm font-medium transition-all duration-200 whitespace-nowrap min-w-0 flex-shrink-0 ${
                    activeTab === tab.id
                      ? 'bg-white text-primary shadow-md'
                      : 'text-white/90 hover:text-white hover:bg-white/20'
                  }`}
                >
                  <span className="block md:hidden">{tab.shortName}</span>
                  <span className="hidden md:block">{tab.name}</span>
                </button>
              ))}
            </div>
          </div>
        </div>
      </HeroSection>

      {/* 콘텐츠 영역 */}
      <div className="max-w-7xl mx-auto px-2 md:px-4 py-6 md:py-12">
        <div className="transition-all duration-300">
          {renderTabContent()}
        </div>
      </div>
    </div>
  );
};

export default ClinicIntroPage; 